import { Defaults } from 'es-decorators'
import { View } from 'es6/components/view'
import { Popup } from 'es6/libs/popup'
import $ from 'init/jquery'
import { positionCenterOfWindow } from 'helpers/popup-positioning-helper'
import { isMobile } from 'init/is-mobile'
import Backbone from 'init/backbone'

/**
 * Базовый Popup, подойдет для создания простых Popup'ов
 * @param {Object} css местоположение поп-апа
 * @param {boolean} isInCenterOfWindow выравнивание по центру
 * @param {boolean} isBlockScreen блокирует экран
 */
@Defaults({
  additionalOptions: ['css', 'isInCenterOfWindow', 'isBlockScreen'],
  isBlockScreen: true,
})
export class PopupView extends View {
  /**
   * @inheritDoc
   */
  run () {
    const opener = this.$el,
      css = this.css ? this.css(opener) : {},
      popupId = this.$el.data('id'),
      popup = $(`[data-popup-id="${popupId}"]`)
    this.initPopup(popup, opener, css)
  }

  /**
   * Инициализация попапа
   * @param {jQuery} popup
   * @param {jQuery} opener
   * @param {Object} css
   */
  initPopup (popup, opener, css) {
    this.popup = new Popup(popup, opener)
    this.popup.addEventListener(
      Popup.EventType.BEFORE_OPEN,
      () => {
        this.handleBeforeOpenEvent(popup, css)
      },
    )
    this.popup.addEventListener(
      Popup.EventType.BEFORE_CLOSE,
      () => {
        this.handleBeforeCloseEvent()
      },
    )
  }

  /**
   * Обработка события, срабатывающего перед открытием попапа
   * @param {jQuery} popup - элемент попаппа
   * @param {Object} css - обьект с css свойствами
   */
  handleBeforeOpenEvent (popup, css) {
    this.toggleBlockScreen(this.isBlockScreen)
    if (!isMobile) {
      this.isInCenterOfWindow ? positionCenterOfWindow(popup) : popup.css(css)
    }
  }

  /**
   * Включение Блокировки экрана
   * @param {boolean} screenIsBlocked состояния экрана
   */
  toggleBlockScreen (screenIsBlocked) {
    Backbone.trigger('block-screen', null, screenIsBlocked)
  }

  /**
   * Обработка события, срабатывающего перед закрытием попапа
   */
  handleBeforeCloseEvent () {
    if (isMobile) {
      this.isBlockScreen && this.toggleBlockScreen(false)
    }
  }
}
